import { render } from "./subRetailerList.vue?vue&type=template&id=09f3fad8&scoped=true"
import script from "./subRetailerList.vue?vue&type=script&lang=js"
export * from "./subRetailerList.vue?vue&type=script&lang=js"

import "./subRetailerList.vue?vue&type=style&index=0&id=09f3fad8&scoped=true&lang=css"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f3fad8"]])

export default __exports__